/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const graphMutationBodyAddNodesItemClientIdMax = 36;

export const graphMutationBodyAddNodesItemClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const graphMutationBodyAddNodesItemContentTypeClientIdMax = 36;

export const graphMutationBodyAddNodesItemContentTypeClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const graphMutationBodyAddNodesItemTypeDescriptionMax = 2000;

export const graphMutationBodyEditNodesItemContentTypeClientIdMax = 36;

export const graphMutationBodyEditNodesItemContentTypeClientIdRegExp = new RegExp(
  '^[a-z0-9._:-]+$',
);
export const graphMutationBodyEditNodesItemTypeDescriptionMax = 2000;

export const graphMutationBodyRootClientIdsItemMax = 36;

export const graphMutationBodyRootClientIdsItemRegExp = new RegExp('^[a-z0-9._:-]+$');
export const graphMutationBodySetEdgesItemFromClientIdMax = 36;

export const graphMutationBodySetEdgesItemFromClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const graphMutationBodySetEdgesItemToClientIdMax = 36;

export const graphMutationBodySetEdgesItemToClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');

export const GraphMutationBody = zod.object({
  addNodes: zod
    .array(
      zod.object({
        clientId: zod
          .string()
          .min(1)
          .max(graphMutationBodyAddNodesItemClientIdMax)
          .regex(graphMutationBodyAddNodesItemClientIdRegExp)
          .describe(
            'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
          ),
        contentTypeClientId: zod
          .string()
          .min(1)
          .max(graphMutationBodyAddNodesItemContentTypeClientIdMax)
          .regex(graphMutationBodyAddNodesItemContentTypeClientIdRegExp)
          .optional()
          .describe(
            'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
          ),
        contentTypeUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        occurredAt: zod.string().optional(),
        subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
        typeDescription: zod
          .string()
          .min(1)
          .max(graphMutationBodyAddNodesItemTypeDescriptionMax)
          .optional(),
        typeName: zod.string().min(1).optional(),
        value: zod
          .object({
            booleanValue: zod.boolean().nullish(),
            dateValue: zod.string().nullish(),
            datetimeValue: zod.string().nullish(),
            numericValue: zod.number().nullish(),
            stringValue: zod.string().nullish(),
          })
          .optional(),
        valueType: zod.enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME']).optional(),
        variant: zod.enum(['TYPE', 'INSTANCE']).optional(),
      }),
    )
    .optional(),
  deleteLineageUuids: zod.array(zod.uuid().describe('UUID v4 identifier')).optional(),
  editNodes: zod
    .array(
      zod.object({
        contentTypeClientId: zod
          .string()
          .min(1)
          .max(graphMutationBodyEditNodesItemContentTypeClientIdMax)
          .regex(graphMutationBodyEditNodesItemContentTypeClientIdRegExp)
          .optional()
          .describe(
            'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
          ),
        contentTypeUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        contentUuid: zod.uuid().describe('UUID v4 identifier'),
        occurredAt: zod.string().optional(),
        subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
        typeDescription: zod
          .string()
          .min(1)
          .max(graphMutationBodyEditNodesItemTypeDescriptionMax)
          .optional(),
        typeName: zod.string().min(1).optional(),
        value: zod
          .object({
            booleanValue: zod.boolean().nullish(),
            dateValue: zod.string().nullish(),
            datetimeValue: zod.string().nullish(),
            numericValue: zod.number().nullish(),
            stringValue: zod.string().nullish(),
          })
          .optional(),
        variant: zod.enum(['TYPE', 'INSTANCE']).optional(),
      }),
    )
    .optional(),
  ownership: zod.enum(['user_owned', 'agent_owned']),
  removeEdges: zod
    .array(
      zod.object({
        fromContentUuid: zod.uuid().describe('UUID v4 identifier'),
        toContentUuid: zod.uuid().describe('UUID v4 identifier'),
      }),
    )
    .optional(),
  rootClientIds: zod
    .array(
      zod
        .string()
        .min(1)
        .max(graphMutationBodyRootClientIdsItemMax)
        .regex(graphMutationBodyRootClientIdsItemRegExp)
        .describe(
          'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
        ),
    )
    .optional()
    .describe(
      'Added root INSTANCE client IDs only. TYPE nodes and contained child INSTANCE nodes are not roots.',
    ),
  rootContentUuids: zod.array(zod.uuid().describe('UUID v4 identifier')).optional(),
  setEdges: zod
    .array(
      zod.object({
        carbonCopy: zod.boolean().optional(),
        certainty: zod.enum(['ASSERTED', 'INFERRED', 'SUGGESTED']).optional(),
        edgeDescription: zod.string().nullish(),
        edgeKey: zod.string().nullish(),
        edgeType: zod.enum(['CONTAINS', 'RELATES_TO', 'INCLUDES']),
        fromClientId: zod
          .string()
          .min(1)
          .max(graphMutationBodySetEdgesItemFromClientIdMax)
          .regex(graphMutationBodySetEdgesItemFromClientIdRegExp)
          .optional()
          .describe(
            'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
          ),
        fromContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        maxCount: zod.int().nullish(),
        minCount: zod.int().nullish(),
        position: zod.int().nullish(),
        toClientId: zod
          .string()
          .min(1)
          .max(graphMutationBodySetEdgesItemToClientIdMax)
          .regex(graphMutationBodySetEdgesItemToClientIdRegExp)
          .optional()
          .describe(
            'Caller-supplied temporary node reference, unique within the request. Used to wire edges and to look up the created UUID in the response. Use lowercase letters, numbers, dots, underscores, colons, or hyphens.',
          ),
        toContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
      }),
    )
    .optional(),
  source: zod
    .object({
      messageContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
      reachThreadId: zod.uuid().optional().describe('UUID v4 identifier'),
    })
    .optional(),
  subjectUuid: zod.uuid().optional().describe('UUID v4 identifier'),
});

export type GraphMutationBody = zod.input<typeof GraphMutationBody>;
export type GraphMutationBodyOutput = zod.output<typeof GraphMutationBody>;
